<div class="grid-x">
    <ag-grid-angular [gridOptions]="gridOptions" class="data-grid " [attr.aria-label]="widgetTitle"></ag-grid-angular>
</div>
